import API from 'services/API';

export default function getParticipationInfo() {
  return API.request({
    method: 'GET',
    url: '/profile/orgStatus',
  });
}
